<template>
  <div id="matching-tags">
    <div class="header">
      <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + $route.params.runtime_face_uuid" />
      Matching Tags for runtime_face_uuid={{$route.params.runtime_face_uuid}}<br />
    </div>
    <div class="matches-area">
      <div class="match-row" v-for="tag in matching_tags" :key="tag.runtime_face_uuid">
        <div class="image-area">
          <img :src="'http://node-runner.p.owal.io:9612/faceimage/' + tag.runtime_face_uuid" />
          <img :src="imageUriForFrontendFaceUUID(tag.frontend_face_uuid)" />
        </div>
        <div class="info-area">
          {{diffformat(tag.diff)}} diff with {{personNameForUUID(tag.frontend_face_uuid)}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {facesmatchingtags} from '../api/faces';

export default {
  name: 'matching-tags',
  data: function() {
    return {
      matching_tags: []
    }
  },
  computed: mapGetters(['frontendFaces', 'isLoggedIn']),
  created() {
    this.updateResults()
  },
  methods: {
    diffformat(diff) {
      if (!diff) return ''; return diff.toFixed(2)
    },
    personNameForUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      return face.person_name;
    },
    imageUriForFrontendFaceUUID(frontend_face_uuid) {
      if (!frontend_face_uuid) return '';
      const face = this.frontendFaces.find(x => x.frontend_face_uuid == frontend_face_uuid);
      if (!face) {
        console.log(`frontend face not found: ${frontend_face_uuid}`);
        return '';
      }
      if (!face.images || !face.images.length) {
        console.log(`frontend face has no images: ${frontend_face_uuid}`);
        return '';
      }
      return face.images[0].thumbnail_uri;
    },
    updateResults() {
      const runtime_face_uuid = this.$route.params.runtime_face_uuid;
      facesmatchingtags(runtime_face_uuid).then(res => res.data).then(data => {
        if (!data.ok) {
          console.error(`${data.err}`)
          return
        }
        this.matching_tags = data.matching_tags;
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// MatchingTags.vue?1d2d2304